import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from './views/home/index';
import ProductList from './views/productList';
import ProductDetail from './views/productDetail';
import AboutUs from './views/aboutUs';
import "@fortawesome/fontawesome-free/css/all.css";
import Admin from "./layouts/Admin.js";
import Auth from "./layouts/Auth.js";
import Slider from "./layouts/UpdateSliderPage.js";
import Comment from './layouts/CommentPage.js';
import Project from "./layouts/Project.js";
import EditProjectPage from "./layouts/EditProjectPage";
import PageNotFound from './views/PageNotFound';
import UploadTest from './views/aboutUs/test';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path='/ProductList' element={<ProductList />} />
        <Route exact path='/ProductDetail' element={<ProductDetail />} />
        <Route exact path='/AboutUs' element={<AboutUs />} />
        <Route exact path='/PageNotFound' element={<PageNotFound />}/>
        {/* <Route exact path='/UploadTest' element={<UploadTest />}/> */}
        {/*}
        <Route exact path="/cms/admin/dashboard" element={<Admin/>} />
        */}
        <Route exact path="/cms/admin/slider" element={<Slider/>} />
        <Route exact path="/cms/admin/comment" element={<Comment/>} />
        <Route exact path="/cms/admin/project" element={<Project />} />
        <Route exact path="/cms/admin/project/projectDetail/:projectID" element={<EditProjectPage />} />
        <Route exact path="/cms/admin/login" element={<Auth />} />
        <Route path='*' element={<PageNotFound />}/>
      </Routes>
    </BrowserRouter>
  );
}
export default App;
